import { Injectable } from "@angular/core";
import { UserData } from "@models/user.model";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, exhaustMap, filter, map, tap } from "rxjs/operators";
import * as AccountActions from "../actions/account.actions";
import { AccountService } from "../services";
import { AccountStoreService } from "../services/account-store.service";

@Injectable()
export class AccountEffects {
  loadAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AccountActions.loadAccount),
      exhaustMap(() =>
        this.account.fetchData().pipe(
          map((data) => AccountActions.loadAccountSuccess({ user: data })),
          catchError((error) =>
            of(AccountActions.loadAccountFailure({ error }))
          )
        )
      )
    )
  );
  reloadAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AccountActions.reloadAccount),
      exhaustMap(() =>
        this.account.fetchData().pipe(
          map((data) => AccountActions.reloadAccountSuccess({ user: data })),
          catchError((error) =>
            of(AccountActions.reloadAccountFailure({ error }))
          )
        )
      )
    )
  );
  saveInStore$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          AccountActions.loadAccountSuccess,
          AccountActions.reloadAccountSuccess,
          AccountActions.updateAccountDataSuccess
        ),
        filter((user) => user?.user.platform?.name === "admin"),
        tap(({ user }) => {
          this.accountStore.setUser(user as UserData);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private account: AccountService,
    public accountStore: AccountStoreService
  ) {}
}
